import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { Link, IndexLink, browserHistory } from 'react-router';

import * as userActions from '../actions/userActions';
import UserApi from '../api/mockUserApi';
import Header from './common/Header';

class App extends React.Component {
	constructor(props, context) {
		super(props, context);

		this.state = {
			user: Object.assign({}, props.user),
			navClass: "inactive",
			errors: {},
			saving: false
		};

		this.toggleNav = this.toggleNav.bind(this);
		this.onSignOut = this.onSignOut.bind(this);
	}

	toggleNav() {
		let css = (this.state.navClass === "inactive") ? "active" : "inactive";
		this.setState({navClass:css});	
	}

	onSignOut() {	
		//console.log("signing out");
		this.props.actions.loadUser([]);	
		browserHistory.push('/login');
		this.setState({navClass:"inactive"});	
	}

	render() {
		return (
			<div className="body-container">
				<Header 
					user={this.props.user}
					collection={this.props.collection}
					recipe={this.props.recipe}
					recipes={this.props.recipes}
					loading={this.props.loading}
					toggleNav={this.toggleNav}
					navClass={this.state.navClass}
					onSignOut={this.onSignOut}
					pathName={this.props.location.pathname}
				/>
				{this.props.children}
			</div>
		);
	}
}

App.propTypes = {
	user: PropTypes.array.isRequired,
	recipe: PropTypes.array.isRequired,
	recipes: PropTypes.array.isRequired,
	collection: PropTypes.array.isRequired,
	children: PropTypes.object.isRequired,
	actions: PropTypes.object.isRequired,
	loading: PropTypes.bool.isRequired,
	location:PropTypes.object.isRequired
};

//pull in react-router for availability on this.context.router
App.contextTypes = {
	router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
	return {
		user: state.user,
		collection: state.collection,
		recipe: state.recipe,
		recipes: state.recipes,
		loading: state.ajaxCallsInProgress > 0
	};
}

function mapDispatchToProps(dispatch) {
	//debugger;
	return {
		actions: bindActionCreators(userActions, dispatch)
	};
}

export default connect(mapStateToProps,mapDispatchToProps)(App);


/** WEBPACK FOOTER **
 ** ./src/components/App.js
 **/